import { DEFAULT_CODE_KERNEL_LANG } from "../../../shared/worksheets/code-kernels";
import { formatDjangoDurationFieldToDaysCount } from "../due-date-form-helpers";

import type {
  GeneralFormValues,
  GradeFormValues,
  SectionInfoFormValues,
  VirtualClassFormValues,
} from "./types";

import type { SectionType } from "components/server-types";

export const getGeneralFormDefaultValues = (
  section: SectionType | null | undefined,
): GeneralFormValues => {
  const lateInterval = section?.default_late_submission_interval;
  const daysLate = formatDjangoDurationFieldToDaysCount(lateInterval ?? null);
  const allowLateSubmissions = daysLate > 0;

  return {
    allowLateSubmissions,
    anonymous_grading_enabled: section?.anonymous_grading_enabled ?? false,
    code_blocks_default_language: section?.code_blocks_default_language || DEFAULT_CODE_KERNEL_LANG,
    code_blocks_enabled: section?.code_blocks_enabled ?? false,
    section_language: section?.section_language ?? "unspecified",
    daysLate: allowLateSubmissions ? daysLate : 1,
    hide_static_blocks_on_student_response_page:
      section?.hide_static_blocks_on_student_response_page ?? false,
    projector_zoom: section?.projector_zoom ?? 100,
    should_lock_pages_at_due_date: section?.should_lock_pages_at_due_date ?? false,
    student_ai_assistant_enabled: section?.student_ai_assistant_enabled ?? false,
    ai_assessment_enabled: section?.ai_assessment_enabled ?? false,
  };
};

export const getSectionInfoFormDefaultValues = (
  section: SectionType | null | undefined,
): SectionInfoFormValues => ({
  title: section?.title ?? "",
  description: section?.description || "",
  external_section_id: section?.external_section_id || "",
  course_id: section?.course_id || "",
  term_id: section?.term_id || "",
});

export const getGradeFormDefaultValues = (
  section: SectionType | null | undefined,
): GradeFormValues => ({
  section_score_enabled: section?.section_score_enabled ?? false,
  section_score_prepwork_percentage: section?.section_score_prepwork_percentage ?? 0,
  section_score_activities_percentage: section?.section_score_activities_percentage ?? 0,
  section_score_assignments_percentage: section?.section_score_assignments_percentage ?? 0,
});

export const getVirtualClassFormDefaultValues = (
  section: SectionType | null | undefined,
): VirtualClassFormValues => ({
  auto_recordings_enabled: section?.auto_recordings_enabled ?? false,
  av_enabled: section?.av_enabled ?? false,
  av_service: section?.av_service ?? "",
  mute_students_on_main_room_entry: section?.mute_students_on_main_room_entry ?? false,
});
